import { render, staticRenderFns } from "./page-refresh.vue?vue&type=template&id=5de67638&scoped=true&"
import script from "./page-refresh.vue?vue&type=script&lang=js&"
export * from "./page-refresh.vue?vue&type=script&lang=js&"
import style0 from "./page-refresh.vue?vue&type=style&index=0&id=5de67638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de67638",
  null
  
)

export default component.exports